import React from 'react'
import styled, { css } from 'styled-components'
import flagAvatar from '../assets/flagAvatar.svg'

const Root = styled.div<{ avatar: string }>`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 33px;
  height: 33px;
  min-width: 33px;
  line-height: 13px;
  font-size: 11px;
  color: ${props => props.theme.color.avatar.text};
  border-radius: 50%;
  background-color: ${props => props.theme.color.avatar.bg};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-image: ${props => css`url("${props.avatar}")`};
`

function getInitials(chatTitle: string) {
  return chatTitle
    .split(' ')
    .slice(0, 2)
    .map((word) => word[0]?.toUpperCase())
    .join('')
}

interface Props {
  initials: string
  avatar: string | Blob
}

const Avatar = (props: Props) => {
  const { initials } = props

  const shortInitials: string = React.useMemo(() => {
    return (props.avatar || !initials) ? '' : getInitials(initials)
  }, [initials, props.avatar])

  const avatar: string = React.useMemo(() => {
    return props.avatar === 'dukascopy' ? flagAvatar
      : props.avatar instanceof Blob ? URL.createObjectURL(props.avatar)
        : props.avatar
  }, [props.avatar])

  return (
    <Root avatar={avatar}>
      {shortInitials}
    </Root>
  )
}

export default Avatar
